/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description null reducer - always returns null
 */

import { alwaysReducer } from './alwaysReducer'

export const nullReducer = alwaysReducer<null>(null)
